import _ from 'lodash';
import { FETCH_PCS } from 'components/Account/AccountComponents/ParentalControls/ParentalControlsActions';
import {
  SET_GOOGLE_ONE_TAP,
  SET_IS_GOOGLE_SIGN_IN,
  SET_IS_GOOGLE_ONE_TAP_DISPLAYED,
  SET_IS_GOOGLE_SIGNED_IN_BROWSER,
  SET_MVPD_PROVIDERS,
  SET_NEXT_MVPD_PROVIDERS_PAGE,
  SET_PREAUTHORIZED_RESOURCES,
  SET_RECOMMENDATION_ID,
  SET_USER_AUTH_DATA,
  SET_USER_PROFILE_CONFIG,
  SET_GOOGLE_EMAIL_AND_TOKEN,
} from './AppActions';

const INITIAL_STATE = {
  account: null,
  anonymousAccount: null,
  anonymousId: null,
  authorizationToken: null,
  buythroughScenario: null,
  deviceId: null,
  googleOneTap: {
    googleOneTapEmail: '',
    googleToken: '',
    isGoogleOneTap: null,
  },
  googleSignIn: {
    googleToken: '',
    isSignedIn: null,
    isGoogleSignIn: null,
    userGoogleEmailAlreadySignIn: '',
  },
  googleNewUser: {
    googleEmail: '',
    googleToken: '',
  },
  isAuthenticated: false,
  isGoogleOneTapDisplayed: null,
  mvpd: null,
  mvpdLogoutData: null,
  mvpdProviders: null,
  pcs: {},
  preauthorizedResources: null,
  recommendationIdData: null,
  segmentDeviceId: null,
  topMVPDProviders: null,
};

const sorter = items => {
  if (!items || !items.length) return null;
  const newItems = items.map(item => {
    const copy = Object.assign({}, item);
    copy.nameLowercase = item.name ? item.name.toLowerCase() : null;
    return copy;
  });
  return _.sortBy(newItems, ['nameLowercase']);
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_MVPD_PROVIDERS: {
      const member = _.get(action, 'payload.data.member');
      const mvpdProviders = sorter(member);
      let totalProviders = 0;
      const maxProviders = 10;
      const topMVPDProviders = mvpdProviders.filter(provider => {
        if (totalProviders > maxProviders) return false;
        if (provider.isFeatured) {
          totalProviders += 1;
          return true;
        }
        return false;
      });

      return {
        ...state,
        mvpdProviders,
        topMVPDProviders,
      };
    }
    case SET_NEXT_MVPD_PROVIDERS_PAGE: {
      const mvpds = _.get(state, 'mvpdProviders');
      let member = _.get(action, 'payload.data.member');
      member = member.concat(mvpds);
      const mvpdProviders = sorter(member);
      let totalProviders = 0;
      const maxProviders = 10;
      const topMVPDProviders = mvpdProviders.filter(provider => {
        if (totalProviders > maxProviders) return false;
        if (provider.isFeatured) {
          totalProviders += 1;
          return true;
        }
        return false;
      });

      return {
        ...state,
        mvpdProviders,
        topMVPDProviders,
      };
    }
    case SET_PREAUTHORIZED_RESOURCES: {
      return {
        ...state,
        preauthorizedResources: action.payload,
      };
    }

    case FETCH_PCS: {
      return {
        ...state,
        pcs: action.payload.data,
      };
    }

    case SET_RECOMMENDATION_ID: {
      return {
        ...state,
        recommendationIdData: action.payload,
      };
    }
    case SET_USER_AUTH_DATA: {
      const data = action.payload;
      if (!data) return state;

      /*
      data may include any or all of the following:
        account,
        anonymousAccount,
        anonymousId,
        authorizationToken,
        buythroughScenario,
        deviceId,
        isAuthenticated,
        mvpd,
        mvpdLogoutData,
        preauthorizedResources,
        segmentDeviceId,
      */

      return {
        ...state,
        ...data,
      };
    }

    case SET_USER_PROFILE_CONFIG: {
      const { profile, profileConfig } = action.payload;
      return {
        ...state,
        profile,
        profileConfig,
      };
    }

    case SET_GOOGLE_ONE_TAP: {
      const { googleOneTapEmail, googleToken, isGoogleOneTap } = action;
      return {
        ...state,
        googleOneTap: {
          ...state.googleOneTap,
          googleOneTapEmail,
          googleToken,
          isGoogleOneTap,
        },
      };
    }

    case SET_IS_GOOGLE_SIGNED_IN_BROWSER: {
      const { googleEmail, googleToken, isSignedIn } = action;
      return {
        ...state,
        googleSignIn: {
          ...state.googleSignIn,
          userGoogleEmailAlreadySignIn: googleEmail,
          googleToken,
          isSignedIn,
        },
      };
    }

    case SET_GOOGLE_EMAIL_AND_TOKEN: {
      const { googleEmail, googleToken } = action;
      return {
        ...state,
        googleNewUser: {
          ...state.googleNewUser,
          googleEmail,
          googleToken,
        },
      };
    }
    case SET_IS_GOOGLE_SIGN_IN: {
      return {
        ...state,
        googleSignIn: {
          ...state.googleSignIn,
          isGoogleSignIn: action.payload,
        },
      };
    }

    case SET_IS_GOOGLE_ONE_TAP_DISPLAYED: {
      return {
        ...state,
        isGoogleOneTapDisplayed: action.payload,
      };
    }
    default:
      return state;
  }
}
